export default function HowItWorksSection() {
  const { t } = useTranslation();
  const steps = [
    { num: t('home.step1_num'), title: t('home.step1_title'), desc: t('home.step1_desc') },
    { num: t('home.step2_num'), title: t('home.step2_title'), desc: t('home.step2_desc') },
    { num: t('home.step3_num'), title: t('home.step3_title'), desc: t('home.step3_desc') },
  ];
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block bg-primary-50 text-primary-600 text-xs font-semibold px-3 py-1 rounded-full tracking-wide uppercase mb-4">{t('home.how_badge')}</span>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 mb-4">{t('home.how_title')}</h2>
          <p className="text-slate-500 text-lg">{t('home.how_subtitle')}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          <div className="hidden md:block absolute top-8 left-[calc(33%+2rem)] right-[calc(33%+2rem)] h-px border-t-2 border-dashed border-slate-200" />
          {steps.map((step, i) => (
            <div key={i} className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-600 text-white font-display font-black text-xl mb-6 relative z-10">
                {step.num}
              </div>
              <h3 className="font-display text-xl font-bold text-slate-900 mb-3">{step.title}</h3>
              <p className="text-slate-500 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
